import { render, staticRenderFns } from "./WaitingList.vue?vue&type=template&id=13036d7e&scoped=true&"
import script from "./WaitingList.vue?vue&type=script&lang=js&"
export * from "./WaitingList.vue?vue&type=script&lang=js&"
import style0 from "./WaitingList.vue?vue&type=style&index=0&id=13036d7e&prod&lang=scss&scoped=true&"
import style1 from "./WaitingList.vue?vue&type=style&index=1&id=13036d7e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13036d7e",
  null
  
)

export default component.exports